import { Injectable } from '@angular/core';
import { CsHttpClientService } from '@cbuild/cs-common-data-services';
import { Observable } from 'rxjs';
import { LeadRequest } from '../to-do/lead-requests/lead-request';
import { ApplicantChangeRequest } from './applicant-change-request/applicant-change-model';
import { CancelRequest } from './cancel-request/cancel-request';
import { Commission } from './commission-approval/commission.model';
import { DiscountRequest } from './discount-request/discount-request';
import { DocumentRequests } from './document-request/document-request';
import { KycRequest } from './kyc-requests/kyc-requests';
import { Milestones } from './milestone-approval/milestone.model';
import { PaymentRequest } from './payment-request/payment-request';
import { PriceModifications } from './price-modifications/price-modifications.model';
import { TDSRequests } from './tds-requests/tds-requests.model';
import { UnitChangeRequest } from './unit-change-requests/unit-change-request';
import { UnitCustomizationRequest } from './unit-customization-requests/unit-customization.model';

@Injectable()
export class ToDoService {
  constructor(private http: CsHttpClientService) {}

  public getKycRequests(): Observable<Array<KycRequest>> {
    return this.http.read('api/to-do/kyc/requests');
  }

  public getDiscountRequests(): Observable<Array<DiscountRequest>> {
    return this.http.read('api/to-do/discount/requests');
  }

  public getPaymentRequests(): Observable<Array<PaymentRequest>> {
    return this.http.read('api/to-do/payment/requests');
  }

  public getCancelUnitRequests(): Observable<Array<CancelRequest>> {
    return this.http.read('api/to-do/cancel-unit/requests');
  }

  public getUnitChangeRequests(): Observable<Array<UnitChangeRequest>> {
    return this.http.read('api/to-do/change-unit/requests');
  }

  public getLeadRequests(): Observable<Array<LeadRequest>> {
    return this.http.read('api/to-do/lead/requests');
  }

  public getApplicantDetailChangeRequests(): Observable<
    Array<ApplicantChangeRequest>
  > {
    return this.http.read('api/to-do/applicant-details-change/requests');
  }

  public getUnitCustomizationRequests(): Observable<
    Array<UnitCustomizationRequest>
  > {
    return this.http.read('api/to-do/unit-customization/requests');
  }

  public getDocumentRequests(): Observable<Array<DocumentRequests>> {
    return this.http.read('api/to-do/document/requests');
  }

  public getCommissions(): Observable<Array<Commission>> {
    return this.http.read('api/to-do/commission/approval');
  }

  public getMilestones(): Observable<Array<Milestones>> {
    return this.http.read('api/to-do/milestone/approval');
  }

  public getTdsRequests(): Observable<Array<TDSRequests>> {
    return this.http.read('api/to-do/tds/approval');
  }

  public getPriceModifications(): Observable<Array<PriceModifications>> {
    return this.http.read('api/to-do/price-modifications/approval');
  }
}
